import './sky-logo-showcase-slider.scss';

let logoSwipers = []; // Array to store all Swiper instances

function initializeLogoSliders() {
    const sliders = document.querySelectorAll('.logo-showcase-slider');

    sliders.forEach(slider => {
        if (!slider.classList.contains('initialized')) {
            const swiperContainer = slider.querySelector('.swiper-container');

            // Check if slides are fully loaded
            const slides = swiperContainer.querySelectorAll('.swiper-slide');
            if (slides.length === 0) {
                console.warn('No logo slides found. Delaying Swiper initialization.');
                return;
            }

            // Get configuration from data attributes
            const speed = parseInt(slider.dataset.speed) || 3000;
            const pauseOnHover = slider.dataset.pauseOnHover === '1';
            const showControls = slider.dataset.showControls === '1';
            const autoScroll = slider.dataset.autoScroll === '1';

            // Calculate slides per view based on number of slides
            const slideCount = slides.length;
            let defaultSlidesPerView = 5;

            if (slideCount < 5) {
                defaultSlidesPerView = slideCount;
            }

            const swiperOptions = {
                slidesPerView: defaultSlidesPerView,
                spaceBetween: 40,
                centeredSlides: slideCount > defaultSlidesPerView,
                loop: slideCount > 1,
                loopedSlides: slideCount > defaultSlidesPerView ? slideCount : null,

                autoplay: autoScroll && slideCount > 1 ? {
                    delay: speed,
                    disableOnInteraction: false
                } : false,

                navigation: showControls ? {
                    nextEl: `#${slider.id} .swiper-button-next`,
                    prevEl: `#${slider.id} .swiper-button-prev`
                } : false,

                // Smooth transitions
                speed: 800,

                // Lazy loading for better performance
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 2
                },

                // Responsive breakpoints
                breakpoints: {
                    1400: {
                        slidesPerView: Math.min(5, slideCount),
                        spaceBetween: 40
                    },
                    1200: {
                        slidesPerView: Math.min(4, slideCount),
                        spaceBetween: 30
                    },
                    992: {
                        slidesPerView: Math.min(3, slideCount),
                        spaceBetween: 30
                    },
                    768: {
                        slidesPerView: Math.min(2, slideCount),
                        spaceBetween: 20
                    },
                    576: {
                        slidesPerView: Math.min(2, slideCount),
                        spaceBetween: 15
                    },
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    }
                }
            };

            // Initialize Swiper
            const swiper = new Swiper(swiperContainer, swiperOptions);
            logoSwipers.push(swiper);

            if (pauseOnHover && autoScroll && slideCount > 1) {
                const wrapper = slider.querySelector('.swiper-wrapper');

                wrapper.addEventListener('mouseenter', () => {
                    if (swiper.autoplay && swiper.autoplay.running) {
                        swiper.autoplay.stop();
                    }
                });

                wrapper.addEventListener('mouseleave', () => {
                    if (swiper.autoplay && !swiper.autoplay.running) {
                        swiper.autoplay.start();
                    }
                });
            }

            // Mark slider as initialized
            slider.classList.add('initialized');

            // Force Swiper to update after initialization
            setTimeout(() => {
                swiper.update();
            }, 100);
        }
    });
}

// Update all logo swipers
function updateLogoSwipers() {
    logoSwipers.forEach(swiper => {
        if (swiper && !swiper.destroyed) {
            swiper.update();
        }
    });
}

// Throttle function for performance
function throttle(func, limit) {
    let inThrottle;
    return function () {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
        }
    }
}

// Debounce function for resize events
function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

// Combine throttle and debounce for efficient resize handling
const efficientResize = (function () {
    const throttledUpdate = throttle(updateLogoSwipers, 200);
    const debouncedUpdate = debounce(updateLogoSwipers, 300);

    return function () {
        throttledUpdate();
        debouncedUpdate();
    }
})();

// Add resize event listener
window.addEventListener('resize', efficientResize);

// Initialize sliders when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    // Short delay to ensure content is loaded
    setTimeout(initializeLogoSliders, 100);
});

// Handle dynamic content with MutationObserver
const observeLogoSliders = () => {
    const targetNode = document.querySelector('.logo-showcase-slider-wrapper') || document.body;

    const observer = new MutationObserver(mutations => {
        let shouldReinitialize = mutations.some(mutation => {
            if (mutation.type === 'childList') {
                return Array.from(mutation.addedNodes).some(node =>
                    node.nodeType === 1 &&
                    (node.classList?.contains('logo-showcase-slider') ||
                        node.querySelector?.('.logo-showcase-slider'))
                );
            }
            return false;
        });

        if (shouldReinitialize) {
            observer.disconnect();

            requestAnimationFrame(() => {
                initializeLogoSliders();
                observer.observe(targetNode, { childList: true, subtree: true });
            });
        }
    });

    observer.observe(targetNode, { childList: true, subtree: true });
};

// Start observing if there are any logo sliders on the page
if (document.querySelector('.logo-showcase-slider')) {
    observeLogoSliders();
}

// Export for potential external use
export { initializeLogoSliders, updateLogoSwipers };